import React from 'react'
import PropTypes from 'prop-types'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

const Banner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 24px;
  background: var(--vo-heatmap-risky);
  border-bottom: 2px solid var(--vo-warning);
  position: sticky;
  top: 64px;
  z-index: 100;
`

const Left = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`

const BannerText = styled.span`
  font-family: 'Maven Pro', sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: var(--vo-warning);
`

const Right = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

const ToggleGroup = styled.div`
  display: flex;
  gap: 3px;
  background: var(--vo-warning-10);
  border-radius: 8px;
  padding: 3px;
`

const ToggleBtn = styled.button`
  height: 28px;
  padding: 0 14px;
  border: none;
  border-radius: 6px;
  background: ${({ $active }) => $active ? 'white' : 'transparent'};
  color: ${({ $active }) => $active ? 'var(--vo-warning)' : 'color-mix(in srgb, var(--vo-warning) 60%, transparent)'};
  font-family: 'Maven Pro', sans-serif;
  font-size: 12px;
  font-weight: ${({ $active }) => $active ? '700' : '500'};
  cursor: pointer;
`

const BackBtn = styled.button`
  height: 32px;
  background: white;
  color: var(--vo-warning);
  border: 1px solid var(--vo-warning);
  border-radius: 8px;
  font-family: 'Maven Pro', sans-serif;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  padding: 0 14px;
  &:hover { background: var(--vo-warning-bg); }
`

const InfoSvg = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="var(--vo-warning)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/>
    <line x1="12" y1="8" x2="12" y2="12"/>
    <line x1="12" y1="16" x2="12.01" y2="16"/>
  </svg>
)

export const PreviewBanner = ({ viewMode, onViewModeChange }) => {
  const { t } = useTranslation('transparency')
  const navigate = useNavigate()

  return (
    <Banner>
      <Left>
        <InfoSvg />
        <BannerText>{t('preview.banner.modeLine')}</BannerText>
      </Left>
      <Right>
        <ToggleGroup>
          <ToggleBtn
            $active={viewMode === 'public'}
            onClick={() => onViewModeChange('public')}
          >
            {t('preview.publicShort')}
          </ToggleBtn>
          <ToggleBtn
            $active={viewMode === 'protected'}
            onClick={() => onViewModeChange('protected')}
          >
            {t('preview.protectedShort')}
          </ToggleBtn>
        </ToggleGroup>
        <BackBtn onClick={() => navigate('/transparency-center/config')}>
          {t('preview.backToSettings')}
        </BackBtn>
      </Right>
    </Banner>
  )
}

PreviewBanner.propTypes = {
  viewMode: PropTypes.string.isRequired,
  onViewModeChange: PropTypes.func.isRequired,
}
